import {
  moveNode,
  moveVertex,
  insertVertexAt,
  removeVertexAt,
  type VertexTarget,
} from "../model/inp/editNetwork.ts";
import type { ElementRef } from "../model/inp/properties.ts";
import type { Point } from "../model/inp/types.ts";

/** NetworkMap/GeoreferencedMap's own mouse-driven drag handles (moving a node/vertex, inserting a midpoint, deleting a vertex) — each just an undoable one-line wrapper over its own `editNetwork.ts` function. */
export function useVertexDragHandlers(
  mutateRawUndoable: (
    fn: (raw: ReadonlyMap<string, string[][]>) => ReadonlyMap<string, string[][]>
  ) => void
) {
  function handleMoveNode(ref: ElementRef, point: Point) {
    mutateRawUndoable((raw) => moveNode(raw, ref, point));
  }

  function handleMoveVertex(target: VertexTarget, index: number, point: Point) {
    mutateRawUndoable((raw) => moveVertex(raw, target, index, point));
  }

  function handleInsertVertex(target: VertexTarget, index: number, point: Point) {
    mutateRawUndoable((raw) => insertVertexAt(raw, target, index, point));
  }

  function handleDeleteVertex(target: VertexTarget, index: number) {
    mutateRawUndoable((raw) => removeVertexAt(raw, target, index));
  }

  return { handleMoveNode, handleMoveVertex, handleInsertVertex, handleDeleteVertex };
}
